import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import NotFound from './pages/NotFound.jsx';
import InstallPWA from './components/InstallPWA.jsx';
import { useAuthStore } from './store/authStore';

function App() {
  const { user, loadUser, token, initialized } = useAuthStore();

  useEffect(() => {
    if (token) {
      loadUser();
    }
  }, [token, loadUser]);

  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <InstallPWA />
      {!initialized ? (
        // A token is present but /auth/me hasn't resolved yet. Render
        // nothing route-based here rather than letting `user ? ... :
        // <Navigate to="/login" />` fire on the stale `user === null` -
        // that redirect would discard the URL the user actually asked for
        // (e.g. reloading mid-call at /dashboard/call/:channelId) before
        // the session finishes restoring.
        <div className="app-boot-loading" role="status" aria-live="polite">
          <div className="app-boot-spinner" />
        </div>
      ) : (
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/dashboard/*"
            element={user ? <Dashboard /> : <Navigate to="/login" />}
          />
          <Route
            path="/"
            element={<Navigate to={user ? "/dashboard" : "/login"} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
